import { useNavigate } from "react-router-dom";
import { ShoppingCartOutlined } from "@ant-design/icons";

import { PhotoDisplayHandler } from "components";
import "./ArticleCard.scss";
import { truncateString } from "utils/helpers/strings";
import LinkLanguage from "locales/LinkLanguage";
import { addArticle } from "store/cart/cart.slice";
import { useDispatch } from "react-redux";
import { showToast } from "utils/helpers/toastHelper";
import { IoCallOutline } from "react-icons/io5";
import { CURRENCY } from "utils/textConstants";
import { useTranslation } from "react-i18next";

import RateComponent from "components/rate/RateComponent";
import FavoriteButtonComponent from "components/favoriteButton/FavoriteButtonComponent";
import { trackEcommerceEvent } from "utils/helpers/analytics";

const ArticleCard = ({ article }: any) => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { t } = useTranslation("home", { useSuspense: false });

  const addToCart = () => {
    dispatch(
      addArticle({
        price: article.article_price.price,
        discount: article.article_price.discount,
        old_price: article.article_price.old_price,
        slug: article.article_slug,
        name: article.article_name,
        image: article.background_image,
        quantity: 1,
      })
    );
    showToast(t("proizvod_dodat_u_korpu"), "success");

    trackEcommerceEvent("add_to_cart", {
      currency: "BAM",
      value: article.article_price.price * 1,
      items: [
        {
          item_id: article.article_slug,
          item_name: article.article_name,
          quantity: 1,
          price: article.article_price.price,
        },
      ],
    });
  };

  return (
    <div className="Aticle-Box">
      <LinkLanguage
        to={`/article/${article.article_slug}`}
        title={t("vidi_detaljno")}
        className="Article-Box-Line1"
      >
        <PhotoDisplayHandler
          img_name={article.background_image}
          calculate={false}
          img_class_name="Article-Box-Image"
          img_alt={article.article_name}
          width="auto"
          height="100%"
        />
        {article.article_price.is_visible && article.article_price.on_sale && (
          <label className="Article-Discount">{t("snizenje")}</label>
        )}
      </LinkLanguage>
      <div className="Article-Box-Line2">
        <LinkLanguage
          to={`/article/${article.article_slug}`}
          title={t("vidi_detaljno")}
          className="Article-Card-Title-Div"
        >
          <p className="Article-Card-Title">
            {truncateString(article.article_name, 50)}
          </p>
        </LinkLanguage>

        <div className="Article-Card-Like">
          <FavoriteButtonComponent
            slug={article.article_slug}
            currentFavorite={article.is_favorite}
          />
        </div>
      </div>

      {article.article_price.is_visible ? (
        <LinkLanguage
          to={`/article/${article.article_slug}`}
          title={t("vidi_detaljno")}
          className="Article-Box-Line3-1"
        >
          <label className="Article-Box-Line3-Label1">
            {article.article_price.price} {CURRENCY}
          </label>
          {article.article_price.on_sale && (
            <label className="Article-Box-Line3-Label2">
              {article.article_price.old_price} {CURRENCY}
            </label>
          )}
        </LinkLanguage>
      ) : (
        <LinkLanguage
          to={`/article/${article.article_slug}`}
          title={t("vidi_detaljno")}
          className="Article-Box-Line3-2"
        >
          <label>{t("cijena_na_upit")}</label>
        </LinkLanguage>
      )}

      <div className="Article-Box-Line4">
        <RateComponent
          slug={article.article_slug}
          currentRate={article.avg_rate}
        />
      </div>
      <div className="Article-Box-Line5">
        {article.article_price.is_visible ? (
          <button onClick={addToCart} className="Article-Card-Button">
            <ShoppingCartOutlined />
            {t("dodaj_u_korpu")}
          </button>
        ) : (
          <button
            onClick={() => navigate("/contact")}
            className="Article-Card-Button"
          >
            <IoCallOutline />
            Kontaktirajte nas
          </button>
        )}
      </div>
    </div>
  );
};
export default ArticleCard;
